export const bookingRoutes = {
	bookingIndex: '/bookings',
	bookingCalendar: '/bookings/calendar',
	bookingAdd: '/bookings/add',
	bookingEdit: (id?: string) => `/bookings/${id ?? ':id'}`,
	bookingHistory: (id?: string) => `/bookings/${id ?? ':id'}/history`
} as const
